import {Col, Select, Typography} from 'antd';
import {ErrorMessage} from 'formik';
import React from 'react';
import {fieldColProps, labelStyle} from '../gridHelpers';

const SelectBox = (props: any) => {
  const {formikProp} = props;
  const selectField: any = props.field;
  const customEvents: any = props.customEvents
    ? props.customEvents[selectField.name] && props.customEvents[selectField.name]
    : {};

  const options = selectField.options?.map((option) => ({
    label: option?.text,
    value: option?.value,
  }));

  const hasError = Boolean(
    formikProp.touched[selectField?.name] && formikProp.errors[selectField?.name],
  );

  return (
    <Col {...fieldColProps(selectField)}>
      <Typography.Text style={labelStyle}>{selectField?.fieldLabel}</Typography.Text>
      <Select
        disabled={selectField.isDisabled ?? false}
        status={hasError ? 'error' : undefined}
        style={{width: '100%'}}
        value={formikProp.values[selectField?.name] ?? undefined}
        options={options}
        onChange={(value) => {
          formikProp.setFieldValue(selectField.name, value);
          customEvents &&
            customEvents.onChange &&
            customEvents['onChange'](
              {target: {name: selectField.name, value}},
              formikProp.setFieldValue,
              formikProp.values,
            );
        }}
      />
      <ErrorMessage name={selectField.name} component="div" />
    </Col>
  );
};

export default SelectBox;
